<script setup lang="ts">
import { NDynamicInput } from 'naive-ui'
import { useAttrs } from 'vue'

const props = withDefaults(defineProps<{
  value?: any[]
  defaultValue?: any[]
  min?: number
  max?: number
  preset?: 'input' | 'pair'
  keyField?: string
  valueField?: string
  itemStyle?: any
  onCreate?: () => any
  onCreateButtonProps?: () => any
  onRemove?: (index: number) => void
  onRemoveButtonProps?: (index: number) => any
  onUpdateValue?: (value: any[]) => void
  onChange?: (value: any[]) => void
}>(), {
  value: () => [],
  defaultValue: () => [],
  min: 0,
  max: undefined,
  preset: 'input',
  keyField: 'key',
  valueField: 'value',
  itemStyle: undefined,
  onCreate: undefined,
  onCreateButtonProps: undefined,
  onRemove: undefined,
  onRemoveButtonProps: undefined,
})

const emit = defineEmits<{
  'update:value': [value: any[]]
  'change': [value: any[]]
  'create': []
  'remove': [index: number]
}>()

const attrs = useAttrs()

const onUpdateValue = (value: any[]) => {
  emit('update:value', value)
}

const onChange = (value: any[]) => {
  emit('change', value)
}

const onCreate = () => {
  emit('create')
}

const onRemove = (index: number) => {
  emit('remove', index)
}
</script>

<template>
  <NDynamicInput
    :value="value"
    :default-value="defaultValue"
    :min="min"
    :max="max"
    :preset="preset"
    :key-field="keyField"
    :value-field="valueField"
    :item-style="itemStyle"
    :on-create="onCreate"
    :on-create-button-props="onCreateButtonProps"
    :on-remove="onRemove"
    :on-remove-button-props="onRemoveButtonProps"
    v-bind="attrs"
    @update:value="onUpdateValue"
    @change="onChange"
  >
    <template #default="{ value: itemValue, index }">
      <slot :value="itemValue" :index="index" />
    </template>
    <template #create-button-default>
      <slot name="create-button-default" />
    </template>
    <template #remove-button-default="{ index }">
      <slot name="remove-button-default" :index="index" />
    </template>
  </NDynamicInput>
</template>

<style scoped>
/* Custom styles can be added here if needed */
</style>
